import { ButtonProps } from "@atoms/Button/Button.types"
import { Button, CountDown } from "@atoms/index"

import useOTPForm from "@organisms/OTPForm/OTPForm.store"

export default function OTPSendCodeButton(props: Partial<ButtonProps>) {
    const {
        handleSendCode,
        isVerifyingCode,
        isRequestingCode,
        isCodeResendBlocked,
        setIsCodeResendBlocked,
        initialCountdownSeconds,
    } = useOTPForm()

    const onCountDownEnds = () => setIsCodeResendBlocked(false)

    return (
        <Button
            variant="subtle"
            size="lg"
            onClick={handleSendCode}
            isProcessing={isRequestingCode}
            isDisabled={isCodeResendBlocked || isVerifyingCode}
            isFullWidth={true}
            {...props}
        >
            Resend code{" "}
            {isCodeResendBlocked && (
                <>
                    in <CountDown onExpire={onCountDownEnds} seconds={initialCountdownSeconds} />
                </>
            )}
        </Button>
    )
}
